// extracted by mini-css-extract-plugin
export default {"madeby__box":"madeby_madeby__box__aPIao","heart":"madeby_heart__1cFva","myname":"madeby_myname__3w4DF","icon__box":"madeby_icon__box__p5nBJ","icon_link":"madeby_icon_link__4uRTg"};